function findUpandDownV1(data, preData, nextData, startPoint, endPoint, long, leftIn, rightIn, leftPage, rightPage, i) {
	const dL = data[i].dataLength
	let val_high_left, val_low_left, val_high_right, val_low_right
	let left_diff = 0, right_diff = 0
	if (leftIn === 0) {
		val_high_left = preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1)))
		val_low_left = preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1)))
		for (let j = 1; j <= long / 2; j++) {
			let left_val, right_val
			if (startPoint + (dL - 1) * (leftPage + 1) + j < dL - 0.5) {
				right_val = preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1) + j))
			} else {
				if (leftPage > 0) {
					right_val = preData[leftPage - 1][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1) + j - dL))
				} else {
					right_val = data[i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1) + j - dL))
				}
			}
			if (startPoint + (dL - 1) * (leftPage + 1) - j > -0.5) {
				left_val = preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1) - j))
			} else {
				left_val = preData[leftPage + 1][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1) - j + dL))
			}
			if (val_high_left < left_val) val_high_left = left_val
			if (val_high_left < right_val) val_high_left = right_val
			if (val_low_left > left_val) val_low_left = left_val
			if (val_low_left > right_val) val_low_left = right_val
		}
		left_diff = val_high_left - val_low_left
	} else {
		val_high_left = data[i].data(Math.round(startPoint))
		val_low_left = data[i].data(Math.round(startPoint))
		for (let j = 1; j <= long / 2; j++) {
			let left_val, right_val
			if (startPoint + j < dL - 0.5) {
				right_val = data[i].data(Math.round(startPoint + j))
			} else {
				right_val = nextData[0][i].data(Math.round((startPoint + j) - dL))
			}
			if (startPoint - j > -0.5) {
				left_val = data[i].data(Math.round(startPoint - j))
			} else {
				left_val = preData[0][i].data(Math.round(dL + (startPoint - j)))
			}
			if (val_high_left < left_val) val_high_left = left_val
			if (val_high_left < right_val) val_high_left = right_val
			if (val_low_left > left_val) val_low_left = left_val
			if (val_low_left > right_val) val_low_left = right_val
		}
		left_diff = val_high_left - val_low_left
	}
	if (rightIn === 0) {
		val_high_right = nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))
		val_low_right = nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))
		for (let j = 1; j <= long / 2; j++) {
			let left_val, right_val
			if (endPoint - (dL - 1) * (rightPage + 1) + j < dL - 0.5) {
				right_val = nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1) + j))
			} else {
				right_val = nextData[rightPage + 1][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1) + j - dL))
			}
			if (endPoint - (dL - 1) * (rightPage + 1) - j > -0.5) {
				left_val = nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1) - j))
			} else {
				if (rightPage > 0) {
					left_val = nextData[rightPage - 1][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1) - j + dL))
				} else {
					left_val = data[i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1) - j + dL))
				}
			}
			if (val_high_right < left_val) val_high_right = left_val
			if (val_high_right < right_val) val_high_right = right_val
			if (val_low_right > left_val) val_low_right = left_val
			if (val_low_right > right_val) val_low_right = right_val
		}
		right_diff = val_high_right - val_low_right
	} else {
		val_high_right = data[i].data(Math.round(endPoint))
		val_low_right = data[i].data(Math.round(endPoint))
		for (let j = 1; j <= long / 2; j++) {
			let left_val, right_val
			if (endPoint + j < dL - 0.5) {
				right_val = data[i].data(Math.round(endPoint + j))
			} else {
				right_val = nextData[0][i].data(Math.round((endPoint + j) - dL))
			}
			if (endPoint - j > -0.5) {
				left_val = data[i].data(Math.round(endPoint - j))
			} else {
				left_val = preData[0][i].data(Math.round(dL + (endPoint - j)))
			}
			if (val_high_right < left_val) val_high_right = left_val
			if (val_high_right < right_val) val_high_right = right_val
			if (val_low_right > left_val) val_low_right = left_val
			if (val_low_right > right_val) val_low_right = right_val
		}
		right_diff = val_high_right - val_low_right
	}
	if (right_diff > left_diff) {
		return 1 - left_diff / right_diff
	} else {
		return -(1 - right_diff / left_diff)
	}
}

function finiteToFixed(value, digits) {
	return Number.isFinite(value) ? value.toFixed(digits) : '-'
}

const TARGET_EEG_CHANNELS = [1, 2, 3, 4, 5, 6]

// Compute amplitude at event creation time.
// Returns { type, values/value } or null if endpoints are out of data range.
export function computeAmplitude(channelId, absFrom, absTo, secondFrom, secondTo, data, preData, nextData) {
	const interval = secondTo - secondFrom
	const isLeftIn = (absFrom >= secondFrom && absFrom <= secondTo) ? 1 : 0
	const isRightIn = (absTo >= secondFrom && absTo <= secondTo) ? 1 : 0

	let leftPage = 0, leftPageFound = isLeftIn === 1
	let rightPage = 0, rightPageFound = isRightIn === 1

	if (isLeftIn === 0) {
		for (let p = 0; p < 5; p++) {
			if (absFrom >= secondFrom - (p + 1) * interval && absFrom <= secondTo - (p + 1) * interval) {
				leftPage = p; leftPageFound = true
			}
		}
	}
	if (isRightIn === 0) {
		for (let p = 0; p < 5; p++) {
			if (absTo >= secondFrom + (p + 1) * interval && absTo <= secondTo + (p + 1) * interval) {
				rightPage = p; rightPageFound = true
			}
		}
	}

	if (!leftPageFound || !rightPageFound) return null

	if (TARGET_EEG_CHANNELS.includes(channelId)) {
		let eegAmps = []
		for (let i = 0; i < 8; i++) {
			const dL = data[i].dataLength
			const startPoint = (dL - 1) * (absFrom - secondFrom) / interval
			const endPoint = (dL - 1) * (absTo - secondFrom) / interval
			let amp = '-'
			try {
				if (isLeftIn && isRightIn) {
					amp = finiteToFixed(Math.abs(data[i].data(Math.round(startPoint)) - data[i].data(Math.round(endPoint))), 1)
				} else if (isLeftIn === 0 && isRightIn === 1) {
					amp = finiteToFixed(Math.abs(preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1))) - data[i].data(Math.round(endPoint))), 1)
				} else if (isLeftIn === 1 && isRightIn === 0) {
					amp = finiteToFixed(Math.abs(data[i].data(Math.round(startPoint)) - nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))), 1)
				} else {
					amp = finiteToFixed(Math.abs(preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1))) - nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))), 1)
				}
			} catch (e) { console.log(e) }
			eegAmps.push(amp)
		}
		return { type: 'eeg', values: eegAmps }
	}

	if (channelId === 12) {
		let eventAmps = []
		for (let i = 1; i < 5; i++) {
			const dL = data[i].dataLength
			const startPoint = (dL - 1) * (absFrom - secondFrom) / interval
			const endPoint = (dL - 1) * (absTo - secondFrom) / interval
			let amp = '-'
			try {
				if (i <= 2) {
					amp = finiteToFixed(findUpandDownV1(data, preData, nextData, startPoint, endPoint, 130, isLeftIn, isRightIn, leftPage, rightPage, i) * 100, 2)
				} else {
					if (isLeftIn && isRightIn) {
						amp = finiteToFixed(Math.abs(data[i].data(Math.round(startPoint)) - data[i].data(Math.round(endPoint))), 1)
					} else if (isLeftIn === 0 && isRightIn === 1) {
						amp = finiteToFixed(Math.abs(preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1))) - data[i].data(Math.round(endPoint))), 1)
					} else if (isLeftIn === 1 && isRightIn === 0) {
						amp = finiteToFixed(Math.abs(data[i].data(Math.round(startPoint)) - nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))), 1)
					} else {
						amp = finiteToFixed(Math.abs(preData[leftPage][i].data(Math.round(startPoint + (dL - 1) * (leftPage + 1))) - nextData[rightPage][i].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))), 1)
					}
				}
			} catch (e) { console.log(e) }
			eventAmps.push(amp)
		}
		return { type: 'resp', values: eventAmps }
	}

	if (channelId === 16) {
		const dL = data[5].dataLength
		const startPoint = (dL - 1) * (absFrom - secondFrom) / interval
		const endPoint = (dL - 1) * (absTo - secondFrom) / interval
		let amp = '-'
		try {
			if (isLeftIn && isRightIn) {
				amp = finiteToFixed(-(data[5].data(Math.round(startPoint)) - data[5].data(Math.round(endPoint))), 1)
			} else if (isLeftIn === 0 && isRightIn === 1) {
				amp = finiteToFixed(-(preData[leftPage][5].data(Math.round(startPoint + (dL - 1) * (leftPage + 1))) - data[5].data(Math.round(endPoint))), 1)
			} else if (isLeftIn === 1 && isRightIn === 0) {
				amp = finiteToFixed(-(data[5].data(Math.round(startPoint)) - nextData[rightPage][5].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))), 1)
			} else {
				amp = finiteToFixed(-(preData[leftPage][5].data(Math.round(startPoint + (dL - 1) * (leftPage + 1))) - nextData[rightPage][5].data(Math.round(endPoint - (dL - 1) * (rightPage + 1)))), 1)
			}
		} catch (e) { console.log(e) }
		return { type: 'spo2', value: amp }
	}

	return null
}
